// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__gANhr","blinker":"Loader_blinker__BXW17","blink":"Loader_blink__p0y5x"};